export class MyCompanyAccountContext {
    public routeTo: string[] = [];
    constructor() {
    }
}
